module.exports = __webpack_public_path__ + "img/cwell2.b90839ba.jpg";